import React from 'react';
import { graphql } from "gatsby";
import PropTypes from 'prop-types';
import ContentBlock from '../../components/contentBlock/contentBlock';
import ModuleWrapper from '../../globals/moduleWrapper/moduleWrapper';

/**
 * 
 * CMS: DatoCmsModuleColumnContent
 * 
 */
const ColumnContent = ({data, className, ...other}) => {
  // console.log('column content',data);
  let {anchor, backgroundColor, border, columns, columnBlocks : content, copy, heading, imageTreatment  } = data;

  return (
    <ModuleWrapper anchor={anchor} border={border} className={`columnContent ${className || ''} ${backgroundColor?.hex === '#262626' ? 'Reversed': 'Default'}`} style={{'background': backgroundColor?.hex}} {...other}>
      {
       ( heading || copy) && <ContentBlock className={`columnContent__intro narrowContent`} data={{'heading': heading, 'content': copy}} />
      }
      <div className={`grid ${(heading || copy) && imageTreatment === 'Logo' ? 'narrowContent' : ''}`} data-columns={columns} data-columns-mobile="1" >
        {
          content?.map((item, i)=>{
            return <ContentBlock headingTag={heading ? 'h3' : 'h2'} data={item} key={i} className={`${imageTreatment} ${!item.content ? 'noCopy': ''}`}/>
          })
        }
      </div>
    </ModuleWrapper>
  );
};

ColumnContent.propTypes = {
    className: PropTypes.string,
    /**
    * Data from cms
    */
    data : PropTypes.shape({
      anchor: PropTypes.string,
      backgroundColor: PropTypes.object,
      border: PropTypes.oneOf(['', 'None', 'Gradient Border Bottom', 'Gradient Border Top', 'Lifted Top', 'Lifted Bottom', 'Lifted Fully']),
      columns: PropTypes.oneOf(['1', '2']),
      content: PropTypes.array,
      copy: PropTypes.string,
      heading: PropTypes.string,
      imageTreatment: PropTypes.oneOf(['Logo', 'Portrait']),
    })
  };

export default ColumnContent;


export const ModuleColumnFragment = graphql`
  fragment ModuleColumnFragment on DatoCmsModuleColumnContent
   {
     
    anchor
    toggleId
    backgroundColor{
      hex
    }
    border
    columns
    columnBlocks : content{
      ...HeadingImageCopyLinkFragment
    }
    copy
    heading
    imageTreatment
  }`;